module.exports = __webpack_public_path__ + "img/11473f1.jpg";